import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Box,
  Button,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  Card,
  CardHeader,
  Tooltip,
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  getFaultWithSanction,
  initiateCase,
} from "../../../store/discipline/actions";
import { showError } from "../../toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AdvertSkeleton from "../../common/components/AdvertSkeleton";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import DeleteIcon from "@mui/icons-material/Delete";
import BackdropLoader from "../../common/components/BackdropLoader";
import defaultProfile from "../../assets/default-profile.jpg";
import SearchBox from "../../common/components/SearchBox";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import TextEditorComponent from "../../common/components/TextEditorComponent";
import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import { replaceTextPlaceholders } from "../../common/components/Utils";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import SignLetter from "../../documents/LetterFormat/SignLetter";
import { getLetterTemplates } from "../../../store/common/actions";
const steps = ["Case Initiation", "Attachments", "Explanation Request Letter"];
const maxCharCount = 30000;

const NewDisplinarlyCaseRequestDialog = (props) => {
  const {
    loading,
    onWait,
    showNewDisplinarlyCaseRequestDialog,
    setShowNewDisplinarlyCaseRequestDialog,
    employee,
    initiateCase,
    faults,
    getFaultWithSanction,
    handleCloseInitiateCase,
    disciplineLetterNo,
    getLetterTemplates,
    setShowCaseDetail,
    isFirstCategory = false,
    letterTemplates,
    isInitiatedBySupervisor,
  } = props;

  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState(null);
  const [searchTeam, setSearchTeam] = useState("");
  const [filteredFaults, setFilteredFaults] = useState([...faults]);
  const [reason, setReason] = useState("INITIATED");
  const [showCaseInitiateForm, setShowCaseInitiateForm] = useState("");
  const [letterFooterContent, setLetterFooterContent] = useState(null);
  const [requestExpLetterTemplate, setRequestExpLetterTemplate] =
    useState(null);
  const [pkiPassword, setPkiPassword] = useState("");

  // console.log(faults);
  const history = useHistory();
  const containerRef = useRef(null);
  const bottomRef = useRef(null);

  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${employee && employee.employeePositionId}-draftExitContent`,
    cc: `${employee && employee.employeePositionId}-copiedInstitution`,
  });

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!letterTemplates.length) getLetterTemplates();
  }, []);

  useEffect(() => {
    if (!faults.length) getFaultWithSanction();
  }, []);

  useEffect(() => {
    const letterTemplatE = letterTemplates.find(({ id }) => id === 1);
    setRequestExpLetterTemplate(letterTemplatE);
  }, [letterTemplates]);

  useEffect(() => {
    const filtered = [...faults].filter(
      ({ faultName, sanction, faultCategoryName }) =>
        (faultName || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (faultCategoryName || "")
          .toLowerCase()
          .includes(searchTeam.toLowerCase()) ||
        (sanction || "").toLowerCase().includes(searchTeam.toLowerCase())
    );

    setFilteredFaults(filtered);
  }, [searchTeam, faults]);

  const [activeStep, setActiveStep] = useState(0);
  const [ccEmails, setCCEmails] = useState([]);
  const [tmpFaults, setTmpFaults] = useState([]);
  const [pdfAttachment, setPdfAttachment] = useState(null);

  const [fileUrl, setFileUrl] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [approver, setApprover] = useState({
    isDelegated: false,
    isMinster: employee?.isMinister || false,
    firstName: employee?.approverFirstName,
    lastName: employee?.approverLastName,
    institutionName: employee?.approverInstitutionName,
    positionName: employee?.approverPositionName,
    institutionName: employee?.approverInstitutionName || "",
    canAddInstitutionName: !employee?.isMinister,
  });

  const [formData, setFormData] = useState({
    employeePositionId: employee.employeePositionId,
    employeeId: employee.id,
    docLetterNo: disciplineLetterNo,
    cc: null,
    attachments: [],
    faults: null,
    caseDescription: "",
    reason: "",
    letterBodyContent: "",
    ccInstitutionNames: "",
    password: "",
    isInitiatedBySupervisor: isInitiatedBySupervisor,
    letterTitle: "",
    approverNames: "",
    approverPositionName: "",
    approverInstitutionName: "",
    approverCanAddInstitutionName: "",
    letterDescription: "",
    isMinster: false,
    appointingAuthorityPlanningEntityId: employee?.appointingAuthorityPlanningEntityId,
    planningEntityId: employee?.planningEntityId,
  });

  const [errors, setErrors] = useState({
    reasonHasError: false,
    effectiveOnHasError: false,
    faultHasError: false,
    docLetterNoError: false,
    ccHasError: false,
    hasError: false,
    attachmentHasErrors: [],
    pdfAttachmentHasError: false,
    draftContentMaxCharHasError: false,
    docLetterNoError: false,
  });

  const formValidator = () => {
    const error = {
      reasonHasError: false,
      effectiveOnHasError: false,
      faultHasError: false,
      docLetterNoError: false,
      ccHasError: false,
      hasError: false,
      attachmentHasErrors: [],
      pdfAttachmentHasError: false,
    };

    if (!tmpFaults.length) {
      error.faultHasError = true;
      error.hasError = true;
    }

    if (!formData.caseDescription) {
      error.reasonHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      scrollToBottom();
      return true;
    }
    return false;
  };

  const formValidator1 = () => {
    const error = {
      reasonHasError: false,
      effectiveOnHasError: false,
      faultHasError: false,
      docLetterNoError: false,
      ccHasError: false,
      hasError: false,
      attachmentHasErrors: [],
      pdfAttachmentHasError: false,
    };

    if (!tmpFaults.length) {
      error.faultHasError = true;
      error.hasError = true;
    }

    if (!formData.caseDescription) {
      error.reasonHasError = true;
      error.hasError = true;
    }
    if ((attachments || [])?.length <= 0) {
      error.pdfAttachmentHasError = true;
      showError("Attachment(s) is/are mandatory");
      error.hasError = true;
    }
    setErrors(error);

    if (error.hasError) {
      scrollToBottom();
      return true;
    }
    return false;
  };

  const formValidator2 = () => {
    const error = {
      attachmentHasErrors: [],
      hasError: false,
      pdfAttachmentHasError: false,
    };
    if ((attachments || [])?.length <= 0) {
      error.pdfAttachmentHasError = true;
      showError("Attachment(s) is/are mandatory");
      error.hasError = true;
    }
    setErrors(error);

    if (error.hasError) {
      return true;
    }
    return false;
  };

  const onClose = () => {
    setFormData({
      employeePositionId: "",
      employeeId: "",
      docLetterNo: "",
      cc: null,
      attachments: [],
      faults: null,
      caseDescription: "",
      reason: "",
      letterBodyContent: "",
      ccInstitutionNames: "",
      password: "",
      isInitiatedBySupervisor: 0,
      letterTitle: "",
      approverNames: "",
      approverPositionName: "",
      approverInstitutionName: "",
      approverCanAddInstitutionName: "",
      letterDescription: "",
      isMinster: false,
    });
    setAttachments([]);
    setPdfAttachment(null);
    setFileUrl(null);
    setShowNewDisplinarlyCaseRequestDialog(false);
    setActiveStep(0);
    if (isFirstCategory) handleCloseInitiateCase();
  };

  const onSave = () => {
    const payload = new FormData();
    formData.attachments = attachments;
    formData.ccEmails = JSON.stringify(ccEmails);
    formData.faults = JSON.stringify(tmpFaults);
    formData.reason = reason;
    formData.letterBodyContent = window.localStorage.getItem(
      localStorageKey.letter
    )
      ? window.localStorage.getItem(localStorageKey.letter)
      : "";
    formData.ccInstitutionNames = window.localStorage.getItem(
      localStorageKey.cc
    )
      ? window.localStorage.getItem(localStorageKey.cc)
      : "";

    if (!letterFooterContent?.entity?.acronym) {
      setActiveStep(2);
      showError(`The institution acronym is missing!`);
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionPhone
    ) {
      setActiveStep(2);
      showError(`The institution phone number is required. Please update it`);
      return false;
    }

    if (
      letterFooterContent?.entity?.institutionPhone.includes("+25078XXXXXXX")
    ) {
      setActiveStep(2);
      showError(
        `The institution phone number (${
          letterFooterContent?.entity?.institutionPhone || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionEmail
    ) {
      setActiveStep(2);
      showError(`The institution email is required. Please update it`);
      return false;
    }

    if (letterFooterContent?.entity?.institutionEmail.includes("example")) {
      setActiveStep(2);
      showError(
        `The institution email (${
          letterFooterContent?.entity?.institutionEmail || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.poBox) {
      setActiveStep(2);
      showError(`The institution PO.Box is required. Please update it`);
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.websiteUrl) {
      setActiveStep(2);
      showError(`The institution website url is required. Please update it`);
      return false;
    }
    if (!!letterFooterContent && !letterFooterContent?.entity?.twitterPage) {
      setActiveStep(2);
      showError(
        `The institution former(twitter) is required. Please update it`
      );
      return false;
    }

    const keys = Object.keys(formData);
    for (const key of keys) {
      if (formData.hasOwnProperty(key)) {
        if (key === "attachments" && formData[key] && !!formData[key].length)
          formData[key].forEach((row, i) => {
            payload.append(key, row.file);
          });
        else payload.append(`${key}`, `${formData[key]}`);
      }
    }
    initiateCase(payload, onClose);
  };

  const handleNext = () => {
    let allowNextStep = false;
    if (!requestExpLetterTemplate) {
      return showError("Request explanation template letter is missing!");
    }
    setFormData({
      ...formData,
      docLetterNo: disciplineLetterNo,
    });

    if (activeStep === 0) {
      if (!formValidator()) {
        allowNextStep = true;
      }
    }

    if (activeStep === 1) {
      if (!formValidator1()) allowNextStep = true;
    }
    if (activeStep === 2) {
      if (!formValidator2()) allowNextStep = true;
    }

    if (allowNextStep && activeStep === 2) setShowCaseInitiateForm(true);

    if (allowNextStep && activeStep < 2) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const convertToLower = (value) => {
    return value.toLowerCase();
  };
  const isFileTooLarge = (file) => {
    const size = file.size;
    return size > 2074190 ? true : false;
  };

  const handleUploadedPDFFile = (event) => {
    setErrors({ ...errors, pdfAttachmentHasError: false });
    let pdfAttachment = event.target.files[0];

    if (
      convertToLower(pdfAttachment?.name?.substr(-4)) !== ".pdf" &&
      pdfAttachment?.type !== "application/pdf"
    ) {
      setErrors({ ...errors, pdfAttachmentHasError: true });
      showError("File should be pdf format");
      event.target.value = null;
    } else if (isFileTooLarge(pdfAttachment)) {
      setErrors({ ...errors, pdfAttachmentHasError: true });
      showError("Allowed file should not exceed 2MB");
      event.target.value = null;
    } else {
      const reader = new FileReader();

      reader.onload = (e) => {
        setFileUrl(e.target.result);
      };

      reader.readAsDataURL(pdfAttachment);

      const tmpDocuments = [...attachments];

      const document = { id: 0, name: "", file: null, url: "" };
      document.name = pdfAttachment?.name;
      document.url = fileUrl;
      document.id = !tmpDocuments.length
        ? 1
        : tmpDocuments[tmpDocuments.length - 1].id + 1;
      document.file = pdfAttachment;

      tmpDocuments.push(document);

      setAttachments(tmpDocuments);

      event.target.value = null;
    }
  };

  // const addPDFFile = () => {
  //   const error = {
  //     pdfAttachmentHasError: false,
  //     hasError: false,
  //   };
  //   if (!pdfAttachment) {
  //     error.pdfAttachmentHasError = true;
  //     error.hasError = true;
  //   }

  //   setErrors(error);

  //   if (error.hasError) {
  //     return true;
  //   }

  //   const tmpDocuments = [...attachments];

  //   const document = { id: 0, name: "", file: null, url: "" };
  //   document.name = pdfAttachment?.name;
  //   document.url = fileUrl;
  //   document.id = !tmpDocuments.length
  //     ? 1
  //     : tmpDocuments[tmpDocuments.length - 1].id + 1;
  //   document.file = pdfAttachment;

  //   tmpDocuments.push(document);
  //   setAttachments(tmpDocuments);
  //   setPdfAttachment(null);
  //   setFileUrl(null);
  //   fileInputRef.current.value = "";
  // };

  const [checked, setChecked] = useState([0]);

  const handleFaultToggle = (fault) => () => {
    const currentIndex = checked.indexOf(fault.id);

    const currentIndex2 = tmpFaults.findIndex(({ id }) => id === fault.id);

    const newChecked = [...checked];
    const uniqueFaults = [...tmpFaults];

    if (currentIndex === -1) {
      newChecked.push(fault.id);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    if (currentIndex2 === -1) {
      uniqueFaults.push(fault);
    } else {
      uniqueFaults.splice(currentIndex2, 1);
    }

    let faultHasError = false;

    setErrors({ ...errors, faultHasError });

    setChecked(newChecked);
    setTmpFaults(uniqueFaults);

    const formattedFaults = uniqueFaults.map((fault) => fault.faultName);

    const faultsListHTML = formattedFaults.length
      ? `<ul style="font-family: Times New Roman;font-size: 16px; margin-left:1px">${formattedFaults
          .map(
            (fault) =>
              `<li style="font-family: Times New Roman;font-size: 16px; margin-left:14px">${fault}</li>`
          )
          .join("<span></span>")}</ul>`
      : "";

    const replacement = {
      faultOrFaults: `${uniqueFaults.length > 1 ? "faults " : "fault"}`,

      faults: `${faultsListHTML}`,

      s: `${uniqueFaults.length > 1 ? "s " : " "}`,
    };

    const letterBodyContent = replaceTextPlaceholders(
      requestExpLetterTemplate?.letterBodyContent,
      replacement
    );
    window.localStorage.setItem(localStorageKey.letter, letterBodyContent);
    setFormData((prevForm) => ({
      ...prevForm,
      letterBodyContent: letterBodyContent,
    }));
  };

  const onSearchFault = (term) => {
    setSearchTeam(term);
  };

  const getEditorContent = (data) => {
    let draftContentMaxCharHasError = false;

    setFormData((prevForm) => ({
      ...prevForm,
      letterBodyContent: data.contents,
    }));

    if (!!data.isMaxChar) draftContentMaxCharHasError = true;

    setErrors({
      ...errors,
      draftContentMaxCharHasError: draftContentMaxCharHasError,
    });
  };
  const getEditorContent3 = (data) => {
    // console.log(data);
    setFormData((prevForm) => ({
      ...prevForm,
      ccInstitutionNames: data.contents,
    }));
    // employeeExitRequest.ccInstitutionNames = data.contents;
  };
  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };

  return (
    <>
      <Dialog
        // onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showNewDisplinarlyCaseRequestDialog}
        fullWidth
        maxWidth={"lg"}
      >
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "70%" }}
          >
            <div className="headerorg mb-0">
              <div className="header_cont">
                <span className="ml-0 text-dark">New Displinarly Case</span> /
                <span className="ml-2">
                  {employee?.lastName} {employee?.firstName}
                </span>
              </div>
            </div>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
          <div className="mt-4">
            <Box sx={{ width: "100%", mt: 0 }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};

                  // stepProps.completed = isCompleted;

                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Box>
          </div>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", minHeight: "60vh" }}>
            <div className="py-0">
              {activeStep === 0 && (
                <Card
                  className={`rounded hoverable-card mb-2 mt-2 pb-3`}
                  variant="outlined"
                  sx={{
                    backgroundColor: `#cdeef8`,
                    border: "none",
                  }}
                >
                  <CardHeader
                    className="pb-0 pt-2"
                    avatar={
                      <Tooltip title={employee.names}>
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-flex",
                            cursor: "default",
                          }}
                        >
                          <Avatar
                            sizes="large"
                            style={{
                              border: "1px solid #d1cbcb",
                            }}
                            alt={employee.names}
                            className=""
                            src={defaultProfile}
                          />
                        </Box>
                      </Tooltip>
                    }
                    title={
                      <span
                        className="d-flex flex-column"
                        style={{ maxWidth: "400px" }}
                      >
                        <span className="d-flex align-items-center text-uppercase font-weight-bold text-primary">
                          {employee.names}
                        </span>
                        <span className="d-block text-primary ml-1 text-sm">
                          {employee.positionName}{" "}
                          {/* <strong className="text-dark">
                                         @{employee.unitName.toUpperCase()}
                                       </strong> */}
                        </span>
                      </span>
                    }
                    subheader={
                      <span className="d-flex align-items-center flex-wrap justify-content-between ">
                        <span className="d-flex align-items-center flex-wrap">
                          <span className="">
                            <span className="d-flex align-items-center  flex-wrap">
                              <span
                                className={`d-flex align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                                style={{
                                  cursor: "default",
                                  borderRadius: "8px",
                                }}
                              >
                                <span className={`badge badge-primary mr-1`}>
                                  {employee?.totalCases || 0}
                                </span>
                                All cases
                              </span>

                              <span
                                className={`d-flex align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                                style={{
                                  cursor: "default",
                                  borderRadius: "8px",
                                }}
                              >
                                <span className={`badge badge-warning mr-1`}>
                                  {employee?.totalOngoing || 0}
                                </span>
                                Ongoing
                              </span>

                              <span
                                className={`d-flex  align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                                style={{
                                  cursor: "default",
                                  // borderRight: "2px solid #ccd0d6",
                                  // borderLeft: "2px solid #ccd0d6",
                                  borderRadius: "8px",
                                }}
                              >
                                <span className={`badge badge-secondary mr-1`}>
                                  {employee?.totalClosed || 0}
                                </span>
                                Closed Cases
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    }
                  />
                </Card>
              )}
              {!faults.length && <AdvertSkeleton />}
              {!!faults.length && (
                <>
                  {activeStep === 0 && (
                    <>
                      <div className="row w-100 mt-2 ml-1" ref={containerRef}>
                        <div className="col-12">
                          <div className="card service-card valid mb-2 mt-1 w-100">
                            <div
                              className="card-header"
                              style={{ padding: "0.25rem 1.2rem" }}
                            >
                              Select fault(s)
                            </div>
                            <div className="card-body">
                              <div className="px-2 pt-2">
                                <SearchBox
                                  disabled={!faults.length}
                                  onSearch={onSearchFault}
                                  placeholder="Search fault(s) ..."
                                />
                              </div>
                              <List
                                sx={{
                                  width: "100%",
                                  bgcolor: "background.paper",
                                  maxHeight: "500px",
                                  overflowY: "auto",
                                }}
                              >
                                {filteredFaults.map(
                                  ({
                                    faultName,
                                    sanction,
                                    id,
                                    faultCategoryName,
                                    faultCategoryId,
                                  }) => {
                                    const labelId = `checkbox-list-label-${id}`;

                                    return (
                                      <>
                                        <ListItem
                                          key={id}
                                          disablePadding
                                          style={{
                                            backgroundColor: `${
                                              checked.indexOf(id) !== -1
                                                ? "#e9ecef"
                                                : ""
                                            }`,
                                          }}
                                        >
                                          <ListItemButton
                                            role={undefined}
                                            onClick={handleFaultToggle({
                                              faultName: faultName,
                                              sanction: sanction,
                                              id: id,
                                              faultCategoryName:
                                                faultCategoryName,
                                              faultCategoryId: faultCategoryId,
                                            })}
                                            dense
                                          >
                                            <ListItemIcon>
                                              <Checkbox
                                                edge="start"
                                                checked={
                                                  checked.indexOf(id) !== -1
                                                }
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                  "aria-labelledby": labelId,
                                                }}
                                              />
                                            </ListItemIcon>
                                            <ListItemText
                                              id={labelId}
                                              primary={faultName}
                                              secondary={
                                                <strong
                                                  className={`d-flex align-items-center text-dark text-uppercase `}
                                                  style={{
                                                    cursor: "default",
                                                    borderRadius: "8px",
                                                    fontSize: "10px",
                                                  }}
                                                >
                                                  Sanction:
                                                  <span
                                                    className={`badge badge-${
                                                      (
                                                        sanction || ""
                                                      ).toLowerCase() ===
                                                      "warning"
                                                        ? "warning"
                                                        : (
                                                            sanction || ""
                                                          ).toLowerCase() ===
                                                          "dismissal"
                                                        ? "danger"
                                                        : (
                                                            sanction || ""
                                                          ).toLowerCase() ===
                                                          "reprimand"
                                                        ? "primary"
                                                        : "secondary"
                                                    } ml-1`}
                                                  >
                                                    {sanction}
                                                  </span>
                                                </strong>
                                              }
                                            />
                                          </ListItemButton>
                                        </ListItem>
                                        <Divider />
                                      </>
                                    );
                                  }
                                )}
                              </List>

                              {errors.faultHasError && (
                                <small className="text-danger mb-1">
                                  Please, select fault(s)
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mt-3 ">
                          <TextField
                            fullWidth
                            size="small"
                            name="caseDescription"
                            required={true}
                            multiline
                            rows={6}
                            value={formData.caseDescription || ""}
                            label={`Case description`}
                            placeholder={`Case description`}
                            inputProps={{ maxLength: 459 }}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                caseDescription: e.target.value,
                              });

                              setErrors({ ...errors, reasonHasError: false });
                            }}
                          />
                          {errors.reasonHasError && (
                            <small className="text-danger mb-1">
                              Please,type case description.
                            </small>
                          )}
                        </div>
                        <div ref={bottomRef}></div>
                      </div>
                    </>
                  )}
                  {activeStep === 2 && (
                    <>
                      <div className="mx-2 w-full">
                        <CustomizedLetter
                          disableToEditLetterHeader={true}
                          enableToFillLetter={true}
                          // planningEntityId={employee?.planningEntityId}
                          ccSelectForm={
                            <>
                              <strong>Enter CC Institution Email</strong>
                              <ReactMultiEmail
                                placeholder="Enter CC Institution Email"
                                emails={ccEmails}
                                onChange={(_emails) => {
                                  setCCEmails(_emails);
                                }}
                                getLabel={(email, index, removeEmail) => {
                                  return (
                                    <div data-tag key={index}>
                                      {email}
                                      <span
                                        data-tag-handle
                                        onClick={() => removeEmail(index)}
                                      >
                                        ×
                                      </span>
                                    </div>
                                  );
                                }}
                              />
                            </>
                          }
                          ccEmails={ccEmails}
                          docLetterNo={formData?.docLetterNo || ""}
                          signContent={
                            <>
                              {isInitiatedBySupervisor === 1 && (
                                <InstitutionDetails
                                  headOfInstitution={approver}
                                  userSignature={null}
                                />
                              )}
                            </>
                          }
                          subTitle={
                            "Dear " +
                            (employee.lastName.toUpperCase() +
                              " " +
                              employee.firstName)
                          }
                          recipientContent={
                            <>
                              {employee.lastName.toUpperCase() +
                                " " +
                                employee.firstName}{" "}
                              <br />
                              Tel: {employee.phoneNumber} <br />
                              Email: {employee.email} <br />
                            </>
                          }
                          // entitySectorId={employee?.entitySectorId || null}
                          planningEntityId={
                            employee?.appointingAuthorityPlanningEntityId ||
                            employee?.planningEntityId ||
                            null
                          }
                          letterBodyContentInput={
                            <>
                              <TextEditorComponent
                                id="editor-exit-textarea"
                                options={{
                                  autoSave: false,
                                  localStorageKey: localStorageKey.letter,
                                  maxCharCount: maxCharCount,
                                  defaultValue: !!window.localStorage.getItem(
                                    localStorageKey.letter
                                  )
                                    ? window.localStorage.getItem(
                                        localStorageKey.letter
                                      )
                                    : formData.letterBodyContent,
                                  styles: {
                                    fontFamily:
                                      letterFooterContent?.styles?.fontFamily ||
                                      "",
                                    fontSize:
                                      letterFooterContent?.styles?.fontSize ||
                                      "",
                                    textAlign:
                                      letterFooterContent?.styles?.textAlign ||
                                      "",
                                    lineHeight:
                                      letterFooterContent?.styles?.lineHeight ||
                                      "",
                                  },
                                }}
                                onEditorChange={(data) => {
                                  getEditorContent(data);
                                }}
                              />
                            </>
                          }
                          letterBodyContent={formData?.letterBodyContent || ""}
                          title={requestExpLetterTemplate?.subject || ""}
                          copiedInstitutionContentInput={
                            <>
                              <br />
                              <strong>Enter CC Institution Name</strong>
                              <TextEditorComponent
                                id="editor-textarea6"
                                options={{
                                  autoSave: false,
                                  height: "auto",
                                  localStorageKey: localStorageKey.cc,
                                  maxCharCount: maxCharCount,
                                  defaultValue: !!window.localStorage.getItem(
                                    localStorageKey.cc
                                  )
                                    ? window.localStorage.getItem(
                                        localStorageKey.cc
                                      )
                                    : formData.ccInstitutionNames,
                                }}
                                onEditorChange={(data) => {
                                  getEditorContent3(data);
                                }}
                              />
                            </>
                          }
                          copiedInstitutionContent={
                            formData?.ccInstitutionNames || ""
                          }
                          loadFooterContent={(data) =>
                            handleLoadFooterContent(data)
                          }
                        />
                      </div>
                    </>
                  )}
                  {activeStep === 1 && (
                    <>
                      <div className="card service-card valid mb-2 mt-1">
                        <div
                          className="card-header"
                          style={{ padding: "0.25rem 1.2rem" }}
                        >
                          Attachments
                        </div>
                        <div className="card-body">
                          <div className="row">
                            {Array.isArray(attachments) &&
                              (attachments || [])?.length > 0 && (
                                <div className="col-lg-12">
                                  {(attachments || [])?.map(
                                    (document, index) => (
                                      <div key={index}>
                                        <div className="form-group1 mb-2">
                                          <div className="input-group">
                                            <div className="input-group-prepend">
                                              <span className="input-group-text">
                                                <i className="fas fa-paperclip"></i>
                                              </span>
                                            </div>

                                            <div
                                              className="form-control"
                                              style={{
                                                backgroundColor:
                                                  "rgb(229, 246, 253)",

                                                color: "#007bff",
                                              }}
                                            >
                                              <span
                                                className="text-truncate d-inline-block"
                                                style={{
                                                  cursor: "pointer",
                                                  maxWidth: "80%",
                                                }}
                                                onClick={() => {
                                                  setShowUploadedDocument(true);
                                                  setUploadedDocument({
                                                    name: document.name,
                                                    url: document.url,
                                                  });
                                                }}
                                              >
                                                {document.name}
                                              </span>

                                              <IconButton
                                                onClick={() => {
                                                  const tmpDocuments = [
                                                    ...attachments,
                                                  ];
                                                  const index =
                                                    tmpDocuments.findIndex(
                                                      ({ id }) =>
                                                        id === document.id
                                                    );

                                                  tmpDocuments.splice(index, 1);
                                                  setAttachments(tmpDocuments);
                                                }}
                                                style={{ marginTop: "-6px" }}
                                                color="error"
                                                className="float-right"
                                                aria-label="delete"
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                              <IconButton
                                                onClick={() => {
                                                  setShowUploadedDocument(true);
                                                  setUploadedDocument({
                                                    name: document.name,
                                                    url: document.url,
                                                  });
                                                }}
                                                style={{ marginTop: "-6px" }}
                                                color="info"
                                                className="float-right"
                                                aria-label="view"
                                              >
                                                <VisibilityIcon />
                                              </IconButton>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}

                            {/* {Array.isArray(attachments) &&
                              (attachments || [])?.length === 0 && (
                                <div className="col-lg-12">
                                  <div className="jumbotron d-flex flex-column justify-content-center align-items-center">
                                    <span
                                      className="lead"
                                      style={{ fontSize: "18px" }}
                                    >
                                      --No record found--
                                    </span>
                                  </div>
                                </div>
                              )} */}
                          </div>
                          <div className="row mx-0 border py-1  border-primary">
                            <div className="col-lg-12">
                              <input
                                type="file"
                                name="file"
                                accept="application/pdf"
                                placeholder="Select pdf file"
                                onChange={(e) => handleUploadedPDFFile(e)}
                                ref={fileInputRef}
                              />
                              {errors.pdfAttachmentHasError && (
                                <small className="text-danger mb-1">
                                  Invalid file
                                </small>
                              )}
                            </div>
                            {/* <div className="col-lg-2 text-right">
                              <Button
                                color="primary"
                                variant="contained"
                                disabled={!!errors.pdfAttachmentHasError}
                                onClick={() => addPDFFile()}
                                size="small"
                              >
                                Add
                              </Button>
                            </div> */}
                          </div>
                        </div>
                      </div>

                      {!!errors?.attachmentHasErrors?.length && (
                        <>
                          {errors.attachmentHasErrors.map((document, index) => (
                            <div key={index}>
                              <div
                                className={`form-group border border-danger p-2`}
                              >
                                <legend
                                  className="w-auto px-2"
                                  style={{
                                    fontFamily:
                                      '"Roboto","Helvetica","Arial",sans-serif',
                                    fontWeight: 400,
                                    fontSize: "0.82rem",
                                    lineHeight: "1em",
                                    letterSpacing: "0.00938em",
                                    color: `red `,
                                  }}
                                >
                                  {index + 1}.{" "}
                                  <span className="ml-1">{document.name}</span>
                                </legend>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </>
                  )}
                  {activeStep === 3 && !!onWait && (
                    <>
                      <BackdropLoader isLoading={onWait} />
                    </>
                  )}
                </>
              )}
              {showUploadedDocument && uploadedDocument && (
                <PreviewPdfUrl
                  isBase64={true}
                  showDocument={showUploadedDocument}
                  setShowDocument={setShowUploadedDocument}
                  document={{
                    name: `View ${uploadedDocument?.name || ""}`,
                    url: uploadedDocument?.url || "",
                  }}
                />
              )}
            </div>
          </Box>
        </DialogContent>
        {!!faults.length && (
          <DialogActions className="d-flex justify-content-center pb-3">
            <Button
              variant="outlined"
              size="md"
              disabled={activeStep === 0 || loading || onWait}
              onClick={handleBack}
            >
              Back
            </Button>

            <Box sx={{ flex: "1 1 auto" }} />

            <Button
              disabled={loading || onWait}
              onClick={handleNext}
              color={"primary"}
              variant="contained"
              size="md"
            >
              {onWait ? "Wait.." : <>Next</>}
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {showCaseInitiateForm && (
        <ConfirmationDialog
          confirmationDialog={showCaseInitiateForm}
          disabled={(isInitiatedBySupervisor === 1 && !pkiPassword) || !reason}
          size="lg"
          message={
            <>
              {isInitiatedBySupervisor === 1 ? (
                <>
                  <p className="px-4">
                    <SignLetter />
                  </p>
                  <p>Enter your RISA Digital signature password to sign</p>
                  <form>
                    <TextField
                      fullWidth
                      size="small"
                      id="pki-password"
                      rows={4}
                      name="pki-password"
                      type="password"
                      label="Enter your RISA Digital signature password to sign"
                      variant="outlined"
                      placeholder="Enter your RISA Digital signature password to sign"
                      value={pkiPassword}
                      onChange={(e) => {
                        setPkiPassword(e.target.value || "");
                      }}
                    />
                  </form>
                </>
              ) : (
                <p>Are you sure you want to submit this case?</p>
              )}
            </>
          }
          setConfirmationDialog={setShowCaseInitiateForm}
          onYes={() => {
            formData.password = pkiPassword;
            formData.approverNames =
              approver.firstName + " " + approver.lastName;
            formData.approverPositionName = approver.positionName;
            formData.approverInstitutionName = approver.institutionName;
            formData.approverCanAddInstitutionName =
              approver.canAddInstitutionName;
            formData.letterDescription =
              requestExpLetterTemplate?.description || "";
            formData.letterTitle = requestExpLetterTemplate?.subject || "";
            formData.isMinster = +approver.isMinster === 1 ? 1 : 0;
            onSave();
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  onWait,
  faults,
  disciplineLetterNo,
  letterTemplates,
}) => {
  return {
    loading,
    onWait,
    faults,
    disciplineLetterNo,
    letterTemplates,
  };
};
export default connect(mapStateToProps, {
  initiateCase,
  getFaultWithSanction,
  getLetterTemplates,
})(NewDisplinarlyCaseRequestDialog);
